<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="mini" ref="form">
            <el-form-item label="国家：" class="query-form-item" prop="state">
                <el-select
                    v-model="query.state"
                    ref="carrerSelect"
                    style="width: 150px;"
                    size="mini"
                    filterable
                >
                    <el-option
                        v-for="item in $common.us_arr"
                        :key="item.us"
                        :label="item.title"
                        :value="item.us"
                        :disabled="item.disabled">
                        <div class="keywords_arr_div">
                            <icon-svg :icon-class="item.us.toUpperCase()"
                                      style="font-size: 24px;margin-right:5px;"></icon-svg>
                            <span style="font-weight: 700; font-size: 14px;margin-left: 10px;">{{
                                    item.title
                                }}</span>
                        </div>
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="月份：" class="query-form-item">
                <el-date-picker v-model="query.date" type="month" value-format="yyyyMM"
                                style="width: 110px" :clearable="false"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="success" icon="el-icon-download" @click="openExportDialog">导出</el-button>
            </el-form-item>
        </el-form>
        <el-table :height="tableHeight" v-loading="loading" :data="list" stripe border style="width: 100%">
            <el-table-column label="国家" width="80" align="center">
                <template slot-scope="scope">
                    <div>
                        <icon-svg
                            :icon-class="scope.row.state.toUpperCase()"
                            style="font-size: 24px;margin-left:5px;"
                        ></icon-svg>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="类目" width="200" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.category || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="合计" width="100" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, 'all_count', false)"></div>
                </template>
            </el-table-column>
            <el-table-column label="待处理" width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '待处理')"></div>
                </template>
            </el-table-column>

            <el-table-column label="新品测试" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '新品测试')"></div>
                </template>
            </el-table-column>

            <el-table-column label="新品推广-重点产品" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '新品推广-重点产品')"></div>

                </template>
            </el-table-column>

            <el-table-column label="推广期" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '推广期')"></div>

                </template>
            </el-table-column>

            <el-table-column label="老品" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '老品')"></div>

                </template>
            </el-table-column>

            <el-table-column label="需要核对情况" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '需要核对情况')"></div>

                </template>
            </el-table-column>

            <el-table-column label="卖完不卖" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '卖完不卖')"></div>

                </template>
            </el-table-column>

            <el-table-column label="不在运营" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '不在运营')"></div>
                </template>
            </el-table-column>

            <el-table-column label="结束" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '结束')"></div>
                </template>
            </el-table-column>
        </el-table>

        <el-dialog title="导出" :visible.sync="exportDialogVisible" width="400px">
            <el-form :model="exportForm" size="mini" label-width="80px">
                <el-form-item label="开始月份">
                    <el-date-picker v-model="exportForm.begin_date" type="month" value-format="yyyyMM"
                                    style="width: 200px" :clearable="false"/>
                </el-form-item>
                <el-form-item label="结束月份">
                    <el-date-picker v-model="exportForm.end_date" type="month" value-format="yyyyMM"
                                    style="width: 200px" :clearable="false"/>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="exportDialogVisible = false">取 消</el-button>
                <el-button type="primary" :loading="exportLoading" @click="confirmExport">导 出</el-button>
            </span>
        </el-dialog>

        <!--        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-size="query.limit"-->
        <!--                       :page-sizes="[10, 20, 50]" :total="total" background :current-page="query.page"-->
        <!--                       style="margin-top: 10px;display: flex;justify-content: end;"-->
        <!--                       layout="total, sizes, prev, pager, next">-->
        <!--        </el-pagination>-->

    </div>
</template>

<script>
import {downloadFileUrl} from '@/utils/method'
import * as api from '@/api/advAnalys/advAnalys.js'

export default {
    data() {
        return {
            tableHeight: null,
            addSubLibraryModal: false,
            query: {
                state: '',
                date: undefined,
                page: 1,
                limit: 20
            },
            exportDialogVisible: false,
            exportLoading: false,
            exportForm: {
                begin_date: '',
                end_date: ''
            },
            list: [],
            total: 0,
            loading: true,
            authList: [],
            defaultProps: {
                children: 'children',
                label: 'title'
            },
            authLoading: false,
            authFormVisible: false,
            authFormData: {
                role_id: '',
                auth_rules: []
            },
            authDefaultCheckedKeys: [],
            index: null,
            formName: null,
            formMap: {
                add: '新增角色',
                edit: '编辑'
            },
            formLoading: false,
            formVisible: false,
            formRules: {
                name: [
                    {required: true, message: '请输入名称', trigger: 'blur'}
                ],
                status: [
                    {required: true, message: '请选择状态', trigger: 'change'}
                ]
            },
            deleteLoading: false
        }
    },
    methods: {
        getDiffDom(data, key, needStart = true) {
            let percentage = (data[key] === 0 ? 0 : data[key] / data.all_count * 100)
            percentage = percentage === 0 ? 0 : percentage.toFixed(2) + '%'
            const start = needStart ? `【${percentage}】` : ''
            const num = (data[key] || 0) - (data['last_' + key] || 0)
            const colorStr = num > 0 ? 'green' : num < 0 ? 'red' : ''
            const arrow = num > 0 ? '↑' : num < 0 ? '↓' : ''
            const style = `color: ${colorStr}; font-weight: bold;`
            const appendStr = num !== 0 ? `(${arrow}${Math.abs(num)})` : ''
            return `<span style="${style}">${start}${data[key]}${appendStr}</span>`
        },
        changeMonth(data) {
            console.log('data', data)
        },
        // 获取当前月份，格式为 'YYYY-MM'
        getCurrentMonth() {
            const now = new Date()
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            console.log('11111:', `${year}${month}`)
            return `${year}${month}`
        },
        jumpUrl(url) {
            if (url) {
                window.open(url, '_blank')
            } else {
                this.$message.warning('没有链接')
            }
        },
        handleDetail(index, data) {
            this.$refs.shipmentDetailRef.showModal(data)
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.addSubLibraryModal = false
            isShow == true && this.getList()
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        onReset() {
            this.query = {
                page: 1,
                limit: 20
            }
            this.getList()
        },
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        openExportDialog() {
            const cur = this.getCurrentMonth()
            this.exportForm.begin_date = cur
            this.exportForm.end_date = cur
            this.exportDialogVisible = true
        },
        async confirmExport() {
            const { begin_date, end_date } = this.exportForm
            if (!begin_date || !end_date) {
                return this.$message.warning('请选择开始与结束月份')
            }
            if (end_date < begin_date) {
                return this.$message.warning('结束月份不能小于开始月份')
            }
            this.exportLoading = true
            try {
                const { data } = await api.export_statistics_kpi_teambition_category({
                    begin_date,
                    end_date,
                    state: this.query.state || undefined
                })
                if (!data) {
                    this.$message.error('导出失败：无返回链接')
                } else {
                    downloadFileUrl(data)
                    this.exportDialogVisible = false
                }
            } catch (e) {
                this.$message.error('导出失败')
            } finally {
                this.exportLoading = false
            }
        },
        uploadFunc() {
            this.addSubLibraryModal = true
        },
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        getList() {
            this.loading = true
            api.statistics_statistics_kpi_teambition_category(this.query).then(response => {
                this.loading = false
                const item = response.data
                const localKeys = Object.keys(item.local_date || {})
                let arr = []
                for (const keyItem of localKeys) {
                    let obj = {}
                    obj.category = keyItem
                    item.local_date[keyItem] && Object.assign(obj, item.local_date[keyItem])
                    obj.last_category = keyItem
                    if (item.last_date) {
                        console.log('item.last_date[keyItem]', item.last_date[keyItem])
                        const lastKyes = Object.keys(item.last_date[keyItem] || {})
                        for (const lastKey of lastKyes) {
                            obj['last_' + lastKey] = item.last_date[keyItem][lastKey]
                        }
                    }
                    arr.push(obj)
                }
                this.list = arr
            }).catch(() => {
                this.loading = false
                this.list = []
                this.total = 0
            })
        },
    },
    mounted() {
        this.query.date = this.getCurrentMonth()
        // 初始化导出表单默认月份为当前月份
        this.exportForm.begin_date = this.query.date
        this.exportForm.end_date = this.query.date
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    created() {
        // 加载表格数据
        this.getList()
    }
}
</script>
